import { UpgradeStep } from './types';

export const progressEstimates: Record<UpgradeStep, { durationMs: number; label?: string }> = {
  migration: { durationMs: 4 * 60 * 1000, label: '3 - 5 minutes' },
  recalculation: { durationMs: 60 * 1000, label: '1 minute' },
  finalization: { durationMs: 20 * 1000 },
};

export function estimateProgress(elapsedMs: number, durationMs: number) {
  if (durationMs <= 0) return 0;
  const elapsedFraction = Math.max(0, elapsedMs) / durationMs;
  const slowdownAt = 0.6;
  const cap = 0.95;
  if (elapsedFraction <= slowdownAt) return elapsedFraction;

  const remaining = cap - slowdownAt;
  return Math.min(cap, slowdownAt + remaining * (1 - Math.exp(-(elapsedFraction - slowdownAt) / remaining)));
}

export function estimateProcessedCount(total: number, progress: number) {
  return Math.max(0, Math.min(total - 1, Math.floor(total * progress)));
}

export function estimateCurrentYear(total: number, progress: number) {
  return total > 0 ? Math.min(total, Math.floor(total * progress) + 1) : 0;
}
